<template>
  <div>
    <import-dialog
      title="Import Fx Volatility"
      :message="importMessage"
      :validate="false"
      :uploadUrl="importUrl"
      :visible="showImportDialog"
      ref="fileUpload"
      v-if="showImportDialog"
      @close="toggleImportDialog"
      @onSuccess="onImportSuccess"
    ></import-dialog>
    <page-toolbar>
      <rate-toolbar @change="onChange" :rate-type="rateType" :key="toolbarKey" v-slot="slotProps">
        <kendo-button
          type="button"
          title="Import data"
          @click="toggleImportDialog"
          v-if="!isReadOnly"
        >
          <v-icon small>archive</v-icon>
        </kendo-button>

        <kendo-button type="button" title="Export to Excel" @click="exportToExcel">
          <i class="k-icon k-i-excel"></i>
        </kendo-button>
      </rate-toolbar>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 165px)"
      ref="rateGrid"
      :dataSource="dataSource"
      :editable="false"
      :filterable="true"
      :sortable="true"
      :columns="columns"
    >
    </kendo-grid>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import notification from '@/helpers/notification'
import PageToolbar from '@/components/PageToolbar'
import ImportDialog from '@/components/ImportDialog'
import RateToolbar from '@/views/Clients/Heroux/MarketData/InterestRate/RateToolbar'
import security from '@/mixins/security'

export default {
  name: 'FxVolatility',
  components: {
    PageToolbar,
    RateToolbar,
    ImportDialog,
  },
  mixins: [security],
  data() {
    return {
      rateType: 6,
      toolbarKey: 0,
      evaluationDateOa: 0,
      gridColumns: [],
      data: [],
      showImportDialog: false,
      importUrl: '/api/heroux/Rate/importVolatility?rateType=6',
      importMessage: '',
    }
  },
  computed: {
    editable() {
      return this.role != 'Guest'
    },
    dataSource() {
      if (!this.data) return
      return new kendo.data.DataSource({
        transport: {
          read: options => {
            options.success(this.data)
          },
        },
        schema: {
          model: {
            fields: {
              EndDate: {type: 'date'},
            },
          },
        },
      })
    },
    columns() {
      if (!this.gridColumns) {
        return
      }
      return this.getGridColumns(this.gridColumns)
    },
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },

  methods: {
    onChange(e) {
      this.getData(e.evaluationDateOa)
      this.evaluationDateOa = e.evaluationDateOa
    },
    getData: async function(evaluationDateOa) {
      const req = await axios
        .get('/api/heroux/rate/readCurrencyRates', {
          params: {
            evaluationDateOa: evaluationDateOa,
            rateType: this.rateType,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error getting dataSource', 'error'))
      const response = req.data
      const {columns, data} = response
      this.gridColumns = columns
      this.data = data
    },
    getGridColumns(columns) {
      const gridColumns = columns.map(column => ({
        ...column,
        width: 120,
        field: '["' + column.curveName + '"]',
        title: column.title,
        filterable: false,
        attributes: {style: 'text-align: right;'},
        format: '{0:n5}',
      }))

      return [
        {
          field: 'EndDate',
          title: 'End Date',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
          hidden: true,
          locked: true,
        },
        {
          field: 'NbDays',
          title: 'Nb Days',
          width: 90,
          attributes: {style: 'text-align: right;'},
          format: '{0:n0}',
          locked: true,
        },
        ...gridColumns,
        {},
      ]
    },
    onImportSuccess(e) {
      const vm = this
      if (e.status == 0) {
        notification(e.message, 'info')
        vm.toolbarKey += 1
        vm.toggleImportDialog()
      } else if (e.status === 5) {
        vm.toolbarKey += 1
        vm.importMessage = e.message
        notification(e.message, 'warning')
      } else {
        vm.importMessage = e.message
        notification(e.message, 'error')
      }
    },
    toggleImportDialog() {
      this.importMessage = ''
      this.showImportDialog = !this.showImportDialog
    },
    exportToExcel() {
      window.location.href = `/api/heroux/rate/exportToExcel?evaluationDateOa=${
        this.evaluationDateOa
      }&rateType=${this.rateType}&t=${this.tokenString}`
    },
  },
}
</script>
